import templateUrl from './in-the-news-list.html';
import publishTemplateUrl from './in-the-news-publish-template.html';
import unpublishTemplateUrl from './in-the-news-unpublish-template.html';
import filter from 'lodash/filter';
import find from 'lodash/find';
import head from 'lodash/head';
import size from 'lodash/size';

export const inTheNewsListComponent = {
    bindings: {
        details: '<',
        parentSlug: '@',
        slugUrl: '@'
    },

    templateUrl,

    controller: class InTheNewsListComponent {
        constructor($state, toastr, ModalService, AboutUsService, DynamicMenusService, SlugService) {
            'ngInject';

            this.$state = $state;
            this.toastr = toastr;
            this.modalService = ModalService;
            this.aboutUsService = AboutUsService;
            this.dynamicMenusService = DynamicMenusService;
            this.slugService = SlugService;
        }

        $onInit() {
            this.details = this.aboutUsService.getInTheNewsDetails(this.details);
            this.tabTemplateUrl = publishTemplateUrl;
            this.isPublishedClicked = true;
            this._setUnpublishNewsList();
            this.totalUnpublishedItems = this.unpublishedNewsList.length;
            this.year = null;
            this.currentPage = 1;
            this.itemPerPage = 10;
            this.filterDetails = {
                'limit': this.itemPerPage,
                'pageId': this.currentPage,
                'isPublished': true
            };
            this.activeTab = "publish";
            this.selectedYearId = head(this.details.year).id;
            this._getPublishNewsList(this.selectedYearId);
        }

        tabChange(status) {
            if (status === 'publish') {
                this.activeTab = "publish"
                this.currentPage = 1;
                this.filterDetails.pageId = this.currentPage;
                this.filterDetails.isPublished = true;
                this.tabTemplateUrl = publishTemplateUrl;
                this.isPublishedClicked = true;
                this._getPublishNewsList(this.selectedYearId);
            } else {
                this.activeTab = "unpublish"
                this.currentPage = 1;
                this.filterDetails.pageId = this.currentPage;
                this.filterDetails.isPublished = false;
                this.tabTemplateUrl = unpublishTemplateUrl;
                this.isPublishedClicked = false;
                this._getUnpublishNewsList();
            }
        }

        onYearChange(id) {
            this.selectedYearId = id;
            this.currentPage = 1;
            this.filterDetails.pageId = this.currentPage;
            this._getPublishNewsList(this.selectedYearId);
        }

        routeAddPageUrl() {
            const url = this.slugService.getAddPageURL(this.slugUrl);

            this.$state.go('app.dashboard.DynamicMenus', {
                url
            });
        }

        routeDetailsPageUrl(slug) {
            const url = this.slugService.getDetailsPageURL(slug);

            this.$state.go('app.dashboard.DynamicMenus', {
                url
            });
        }

        routeEditPageUrl(slug) {
            const url = this.slugService.getEditPageURL(slug);

            this.$state.go('app.dashboard.DynamicMenus', {
                url
            });
        }

        onChange(pageNumber) {
            this.currentPage = pageNumber;
            this.filterDetails.limit = this.itemPerPage;
            this.filterDetails.pageId = this.currentPage;
            this.aboutUsService.getInTheNewsFilterData({ year: this.selectedYearId, filterDetails: this.filterDetails }, this.slugUrl)
                .then(result => {
                    this.details.list = result.list;
                    (this.activeTab === 'publish') ? this._setPublishNewsList() : this._setUnpublishNewsList();
                });
        }

        //on delete the news
        onDelete(slug) {
            this.modalService.open({
                details: {
                    bodyMessage: 'Are you sure you want to delete the news?'
                },

                buttons: [
                    {
                        name: 'No'
                    },
                    {
                        name: 'Yes',
                        isPrimary: true,
                        action: onSubmit.bind(this)
                    }
                ]
            });

            function onSubmit() {
                this.dynamicMenusService.deleteMenuDetailsByUrl(`${slug}/delete`)
                    .then((response) => {
                        this.totalItems -= 1;
                        this.toastr.success("News Deleted successfully");
                    })
                    .then(_ => (this.activeTab === 'publish') ? this._getPublishNewsList(this.selectedYearId) : this._getUnpublishNewsList())
                    .catch((err) => {
                        this.toastr.error(err);
                    });
            }
        }

        publishUnpublishNews(id) {
            this.aboutUsService.publishUnpublishNews(id)
                .then((response) => {
                    let unpublishedItem = find(this.unpublishedNewsList, ['id', id]);
                    unpublishedItem.publishAt = new Date();
                    this.unpublishedNewsList = this.unpublishedNewsList.filter(detail => detail.id !== id);
                    this.publishedNewsList.push(unpublishedItem);
                    this.totalUnpublishedItems -= 1;
                    this.toastr.success("News Published Successfully");
                    this.$state.go('app.dashboard.InTheNews');
                }).catch((err) => {
                    this.toastr.error(err);
                });
        }

        _getPublishNewsList(year) {
            this.aboutUsService.getInTheNewsFilterData({ year, filterDetails: this.filterDetails }, this.slugUrl)
                .then(details => {
                    this.totalItems = details.count;
                    this.totalPublishedItems = this.totalItems;
                    this.publishedNewsList = details.list;
                });
        }

        _getUnpublishNewsList() {
            this.aboutUsService.getInTheNewsFilterData({ year: this.selectedYearId, filterDetails: this.filterDetails }, this.slugUrl)
                .then(details => {
                    this.totalItems = details.count;
                    this.totalUnpublishedItems = this.totalItems;
                    this.unpublishedNewsList = details.list;
                });
        }

        _setPublishNewsList() {
            this.publishedNewsList = this.details.list.filter(item => item.publishAt !== null);
        }

        _setUnpublishNewsList() {
            this.unpublishedNewsList = this.details.list.filter(item => item.publishAt === null);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/about-us/in-the-news/in-the-news-list/in-the-news-list.component.js